import base from '../locales/en';
import aqpro from '../locales/partials/aqpro/en';
import firmament from '../locales/partials/firmament/en';
import radiacodeapp from '../locales/partials/radiacodeapp/en';
import versionCompare from '../locales/partials/versionCompare/en';
import content from '../content/en';
import { buildBundle } from './build';
export default buildBundle(base, { aqpro, firmament, radiacodeapp, versionCompare, content });
